import { Link } from 'react-router-dom';
import { Button } from '@/shared/ui';
import { ROUTES } from '@/shared/config/constants';

export const NotFoundPage = () => (
  <main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-background px-4 text-center">
    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
      <span className="text-2xl font-bold">404</span>
    </div>
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Página não encontrada</h1>
      <p className="mt-1 text-sm text-muted-foreground">
        O endereço que você tentou acessar não existe ou foi movido.
      </p>
    </div>
    <Button asChild>
      <Link to={ROUTES.LOGIN}>Voltar para o início</Link>
    </Button>
  </main>
);
